import { Component, OnInit, OnDestroy } from '@angular/core';
import { SubscriptionManager } from '@zelis/platform-ui-components';
import { Subscription, Observable, iif, of, forkJoin } from 'rxjs';
import { MleService } from '../../../services/mle.service';
import { MleStatus } from '@interfaces/mle-status.model';
import * as _ from 'lodash';
import { EpisodesOfCareConfigService } from '../../../services/eoc/eoc.config.service';
import { EpisodesOfCareService } from '../../../services/eoc/eoc.service';
import { MembersService } from '../../../services/members.service';
import { EpisodeOfCareConfig } from '@interfaces/episode-of-care-config.model';
import { EpisodeOfCare } from '@interfaces/episode-of-care.interface';
import { switchMap, map, first } from 'rxjs/operators';

@Component({
  selector: 'app-episodes-tout',
  templateUrl: './episodes-tout.component.html',
  styleUrls: ['./episodes-tout.component.scss'],
})
export class EpisodesToutComponent implements OnInit, OnDestroy {
  public episodesList: EpisodeOfCare[];
  public subscriptions = new SubscriptionManager();
  public incentivesEnabled: Observable<boolean> =
    this.membersService.incentivesEnabled;
  public carepathConfig: Observable<EpisodeOfCareConfig> =
    this.eocConfigService.getConfig();

  constructor(
    private eocService: EpisodesOfCareService,
    private eocConfigService: EpisodesOfCareConfigService,
    private mleService: MleService,
    private membersService: MembersService
  ) {}

  ngOnInit() {
    this.subscriptions.add(this.subscribeToEpisodesOfCare());
  }

  ngOnDestroy() {
    this.subscriptions.destroy();
  }

  private subscribeToEpisodesOfCare(): Subscription {
    return this.getEpisodesOfCare().subscribe(
      (episodes: EpisodeOfCare[]) =>
        (this.episodesList = this.sortList(episodes))
    );
  }

  private getEpisodesOfCare(): Observable<EpisodeOfCare[]> {
    return forkJoin([
      this.eocConfigService.isEnabled(),
      this.getMleEligible(),
    ]).pipe(
      switchMap(([enabled, mleEligible]) =>
        iif(
          () => enabled && mleEligible,
          this.eocService.getEpisodesOfCare(),
          of(null)
        )
      )
    );
  }

  private getMleEligible(): Observable<boolean> {
    return this.mleService.status.pipe(
      first((status) => status.mle !== undefined),
      map((status) => this.mapMleEligible(status))
    );
  }

  private mapMleEligible(status: MleStatus): boolean {
    return status.mle || status.mle_lite;
  }

  private sortList(list: EpisodeOfCare[]): EpisodeOfCare[] {
    if (!list) {
      return list;
    }
    const tout = _.take(list, 5);
    const sorted = _.sortBy(list.slice(5), ['episode_name']);
    return tout.concat(sorted);
  }
}
